<template>
	<div
		class="row mb-lg-3 mt-lg-1 d-flex flex-column flex-md-row"
		:class="centralizeButtonNL"
	>
		<div
			v-if="!this.isLocaleNL"
			class="col-12 col-md-6 d-flex align-items-center justify-content-center mb-2"
		>
			<button
				@click.stop="handleReserveClick('ask_quote')"
				class="button-secondary bg-none border-primary-blue text-primary-blue d-flex align-items-center justify-content-center w-100"
			>
				<span class="buttons-default">{{
					content.planner_resumeCreateQuote
				}}</span>
			</button>
		</div>
		<div
			class="col-12 col-md-6 d-flex align-items-center justify-content-center mb-2"
		>
			<button
				@click.stop="handleReserveClick('book')"
				class="button-primary primary-normal cursor-pointer d-flex align-items-center justify-content-center w-100"
			>
				<span class="buttons-default">{{ content.planner_resumeOrder }}</span>
			</button>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import store from "@/vue/planning/store/store";

// Tracking
import trackReservationClick from "@/tracking/trackReservationClick";

export default {
	store,
	name: "BotomButtons",
	computed: {
		...mapState(["content"]),
		...mapGetters([
			"bookingProcessURL",
			"totalSelectedHebergements",
			"isFewerParticipantsThanSelectedMaxCapacity",
			"isLocaleNL",
		]),
		centralizeButtonNL() {
			return { "justify-content-center": this.isLocaleNL };
		},
	},
	methods: {
		handleReserveClick(eventName) {
			console.log("store.state: ", store.state);
			const beginDateParts =
				store.state.dates["BeginDate"] &&
				store.state.dates["BeginDate"].split("/");
			const endDateParts =
				store.state.dates["EndDate"] && store.state.dates["EndDate"].split("/");
			const liheId =
				store.getters.selectedPrestations[0].prestation.fusionId ||
				store.state.liheData.id;
			const participants = store.state.participants;
			console.log("participants: ", participants.length);
			const start_date = beginDateParts
				? `${beginDateParts[2]}-${beginDateParts[1]}-${beginDateParts[0]}`
				: "";
			const endDate = endDateParts
				? `${endDateParts[2]}-${endDateParts[1]}-${endDateParts[0]}`
				: "";

			const duration =
				store.getters.selectedPrestations &&
				store.getters.selectedPrestations[0].prestation?.duration;
			const prestationsIds =
				store.getters.selectedPrestations &&
				store.getters.selectedPrestations.map((prest) => {
					console.log("prest.prestation: ", prest.prestation);
					return prest.prestation.prestIdSource;
				});
			const prestationsNames =
				store.getters.selectedPrestations &&
				store.getters.selectedPrestations.map((prest) => {
					return prest.prestation.prestName;
				});
			const totalPrice = store.getters.totals.totalPrice;

			this.$store.dispatch("reserveClick");

			trackReservationClick(
				eventName,
				participants.length,
				prestationsIds,
				prestationsNames,
				totalPrice,
				start_date,
				endDate,
				duration
			);
		},
	},
};
</script>

<style scoped>
.planning-bottom-btn {
	transition: background 150ms ease-in-out, box-shadow 150ms ease-in-out;
}

.planning-bottom-btn.white {
	background: white;
}
.planning-bottom-btn.blue {
	background: #52b3d8;
}

.planning-bottom-btn.white:hover {
	box-shadow: 0px 0px 0px 1px #52b3d8;
}
.planning-bottom-btn.blue:hover {
	background: #3fa6cd;
}
</style>
